import React, { useState, useRef, useEffect } from "react";
import profile1 from "../Image/profile1.png";
import profile2 from "../Image/profile2.png";
import profile3 from "../Image/profile3.png";
import profile4 from "../Image/profile4.png";
import profile5 from "../Image/profile5.png";
import Arrow from "../Image/Arrow.png";
import hoverarrow from "../Image/hover-arrow.png";
import message from "../Image/message.png";

function Rightsidebar({
  chatOpen,
  setChatOpen,
  isSidebarOpen,
  setIsSidebarOpen,
}) {
  const chatpanelRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        chatpanelRef.current &&
        !chatpanelRef.current.contains(event.target)
      ) {
        setChatOpen(false);
      }
    };

    if (chatOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [chatOpen, setChatOpen]);

  return (
    <div>
      <div
        ref={chatpanelRef}
        className={`chat-panel ${chatOpen ? "show" : ""}`}
      >
        <div className="chat-list">
          <div className="chat-item">
            <div className="chat-user d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <img src={profile1} alt="" className="avatar" />
                <h5>Mera N.</h5>
              </div>

              <div className="arrow">
                <img src={Arrow} alt="Arrow" className="normal" />
                <img src={hoverarrow} alt="" className="hover" />
              </div>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry of the printing and typesetting industry.
            </p>
          </div>

          <div className="chat-item">
            <div className="chat-user d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <img src={profile2} alt="" className="avatar" />
                <h5>John P.</h5>
              </div>

              <div className="arrow">
                <img src={Arrow} alt="Arrow" className="normal" />
                <img src={hoverarrow} alt="" className="hover" />
              </div>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting.
            </p>
          </div>

          <div className="chat-item">
            <div className="chat-user d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <img src={profile3} alt="" className="avatar" />
                <h5>Metthew H.</h5>
              </div>

              <div className="arrow">
                <img src={Arrow} alt="Arrow" className="normal" />
                <img src={hoverarrow} alt="" className="hover" />
              </div>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and dummy text of
              the printing and typesetting.
            </p>
          </div>

          <div className="chat-item">
            <div className="chat-user d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <img src={profile4} alt="" className="avatar" />
                <h5>Sigma L.</h5>
              </div>

              <div className="arrow">
                <img src={Arrow} alt="Arrow" className="normal" />
                <img src={hoverarrow} alt="" className="hover" />
              </div>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry of the printing and typesetting industry.
            </p>
          </div>

          <div className="chat-item">
            <div className="chat-user d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <img src={profile5} alt="" className="avatar" />
                <h5>Neeah V.</h5>
              </div>

              <div className="arrow">
                <img src={Arrow} alt="Arrow" className="normal" />
                <img src={hoverarrow} alt="" className="hover" />
              </div>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rightsidebar;
